/**
 * Gerador de Schemas JSON-LD oficiais para o escritório Antonio Saldanha Advocacia
 * Seguindo as diretrizes oficiais do Google Search Central e Schema.org.
 */

export const OFFICE_INFO = {
  name: "Antonio Saldanha Advocacia",
  url: "https://antoniosaldanhaadvocacia.com.br/",
  logo: "https://antoniosaldanhaadvocacia.com.br/apple-touch-icon.png",
  phone: "+55 (11) 95424-2066",
  phoneRaw: "+5511954242066",
  email: "saldanha.advocacia01@gmail.com",
  address: {
    street: "Rua Pais Leme, 215 - Conj 1713",
    neighborhood: "Pinheiros",
    city: "São Paulo",
    state: "SP",
    country: "BR",
    full: "Rua Pais Leme, 215 - Conj 1713 - Pinheiros, São Paulo - SP"
  }
};

export function getLegalServiceSchema() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LegalService",
        "@id": `${OFFICE_INFO.url}#organization`,
        "name": OFFICE_INFO.name,
        "url": OFFICE_INFO.url,
        "logo": OFFICE_INFO.logo,
        "image": OFFICE_INFO.logo,
        "telephone": OFFICE_INFO.phoneRaw,
        "email": OFFICE_INFO.email,
        "priceRange": "$$",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": OFFICE_INFO.address.street,
          "addressLocality": OFFICE_INFO.address.city,
          "addressRegion": OFFICE_INFO.address.state,
          "addressCountry": OFFICE_INFO.address.country
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": -23.5684,
          "longitude": -46.6925
        },
        "areaServed": {
          "@type": "Country",
          "name": "Brasil"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${OFFICE_INFO.url}#website`,
        "url": OFFICE_INFO.url,
        "name": OFFICE_INFO.name,
        "publisher": {
          "@id": `${OFFICE_INFO.url}#organization`
        },
        "inLanguage": "pt-BR"
      }
    ]
  };
}

export function getBreadcrumbSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

export function getFaqSchema(faqList = []) {
  if (!faqList || faqList.length === 0) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqList.map((faq) => ({
      "@type": "Question",
      "name": faq.pergunta,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.resposta
      }
    }))
  };
}
